export default __webpack_public_path__ + "static/media/Oly.3b255eb1.svg";